"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Ref, Vue } from "vue-property-decorator";
import API from "@ym-framework/api-utils";
import _ from "lodash";
import DistributionDialog from "@/components/dialog/DistributionDialog.vue";
import UiGrid, { GridController } from "@/components/grid/UiGrid.vue";
import { APIDataSource } from "@/components/grid/data-source";
let AuthorizationDialog = class extends Vue {
  constructor() {
    super(...arguments);
    this.appid = "";
    this.selectDatas = [];
    this.selectLock = false;
    this.activeName = "first";
    this.searchStr = "";
    this.gridController = new GridController(new APIDataSource("api://base.auth/api/v7/users"));
    this.searchByName = _.debounce((searchStr) => {
      if (searchStr !== null && searchStr !== "") {
        this.gridController.query.filter = `userStatus=='0';name=='%${searchStr}%',account=='%${searchStr}%'`;
      }
      if (searchStr === null || searchStr === "") {
        this.gridController.query.filter = `userStatus=='0'`;
      }
      this.gridController.query.current = 1;
      this.gridController.search();
    }, 500);
  }
  created() {
    this.gridController.on("searched", (item) => {
      this.checkItem();
    });
    this.gridController.pagePosition = "dialog";
    this.gridController.size = true;
    this.gridController.query.filter = `userStatus=='0'`;
  }
  mounted() {
    return __async(this, null, function* () {
    });
  }
  open(appid) {
    this.appid = appid;
    this.searchStr = "";
    this.selectDatas = [];
    this.selectLock = false;
    this.gridController.query.sort = "asc";
    this.gridController.query.params = null;
    this.gridController.query.filter = "";
    this.gridController.search();
    this._distributionDialog.open();
    this.$nextTick(() => __async(this, null, function* () {
      yield this.getUsers();
      this.checkItem();
    }));
  }
  getUsers() {
    return __async(this, null, function* () {
      try {
        const response = yield API.get(`api://base.apps.auth/v1/personal/${this.appid}/users/authorized`);
        if (response.data) {
          for (const item of response.data.datas) {
            this._distributionDialog.add({
              id: item.guid,
              label: `${item["name"]} (${this.getId(item["account"])})`
            });
          }
        }
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  saved(data) {
    return __async(this, null, function* () {
      let userIds = _.map(data, "id");
      try {
        const response = yield API.post(`api://base.apps.auth/v1/personal/apps/${this.appid}/authorize`, {
          ids: userIds
        });
        this.$message.success(this.$t("authorizationdialog.saved_successfully"));
        this._distributionDialog.close();
        this.$emit("refresh");
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  selectItems(items) {
    this.selectDatas = [];
    this.selectDatas = items;
    if (!this.selectLock) {
      let unSelectData = _.differenceWith(this.gridController.result.datas, items, _.isEqual);
      for (const item of items) {
        const _item = {
          id: item["guid"],
          label: `${item["name"]} (${this.getId(item["account"])})`
        };
        this._distributionDialog.add(_item);
      }
      for (const item of unSelectData) {
        const _item = {
          id: item["guid"],
          label: `${item["name"]} (${this.getId(item["account"])})`
        };
        this._distributionDialog.del(_item);
      }
    }
  }
  changed(data) {
    let rows = _.differenceWith(this.selectDatas, data, (selectData, data2) => selectData.guid == data2.id);
    this.selectLock = true;
    if (rows) {
      for (const row of rows) {
        this._multipleTable.toggleRowSelection(row, false);
      }
    }
    this.selectLock = false;
  }
  checkItem() {
    let selectDatas = this._distributionDialog.getAll();
    let rows = _.intersectionWith(this.gridController.result.datas, selectDatas, (selectData, data) => selectData.guid == data.id);
    this.selectLock = true;
    if (rows) {
      for (const row of rows) {
        this._multipleTable.toggleRowSelection(row, true);
      }
    }
    this.selectLock = false;
  }
  getId(account) {
    return account.toString().substring(account.toString().length - 4, account.toString().length);
  }
};
__decorateClass([
  Ref("distributionDialog")
], AuthorizationDialog.prototype, "_distributionDialog", 2);
__decorateClass([
  Ref("multipleTable")
], AuthorizationDialog.prototype, "_multipleTable", 2);
AuthorizationDialog = __decorateClass([
  Component({
    components: {
      UiGrid,
      DistributionDialog
    }
  })
], AuthorizationDialog);
export {
  AuthorizationDialog as default
};
